module.exports = __webpack_public_path__ + "img/bgd6.837ba300.png";